import React, { useState, useEffect } from 'react'
import "./header.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-scroll"

import gif from "../imgz/lastGIF.gif";
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import watsap from "../imgz/WhatsApp-Logo.png";
import chat from "../imgz/chatxx.gif";
import Watsap from './Watsap';

function Header() {

    useEffect(() => {
        Aos.init({ duration: 2000 });
    }, [])


    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);
    const [show2, handleShow2] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 1000) {
                handleShow2(true)
            } else handleShow2(false)
        })
        return () => {
            window.removeEventListener("scroll");
        }
    }, [])


    return (
        <div className="head">
            <div className="left" >
                <img src={gif} alt="" />
            </div>
            <div   className={`${click ? "newright" : "right"} `} >
                <h2  data-aos="fade-left" className="navs1"><Link onClick={() => {setClick(!click)}} to="home" smooth={true} duration={1000}>HOME</Link></h2>
                <h2  data-aos="fade-left" className="navs2"><Link onClick={() => {setClick(!click)}} to="about" smooth={true} duration={1000}>ABOUT US</Link></h2>
                <h2  data-aos="fade-left" className="navs3"><Link onClick={() => {setClick(!click)}} to="service" smooth={true} duration={1000}>SERVICES</Link></h2>
                <h2  data-aos="flip-left" className="navs4"><Link onClick={() => {setClick(!click)}} to="experience" smooth={true} duration={1000}>EXPERIENCES</Link></h2>
                <h2  data-aos="fade-down" className="navs5"><Link onClick={() => {setClick(!click)}} to="projects" smooth={true} duration={1000}>PORTFOLIO</Link></h2>
                <h2  data-aos="fade-down" className="navs6"><Link onClick={() => {setClick(!click)}} to="contact" smooth={true} duration={1000}>CONTACT</Link></h2>
            </div>
            <div className="right1" >
                <h2 data-aos="fade-left" className="navs1"><Link to="home" smooth={true} duration={1000}>HOME</Link></h2>
                <h2 data-aos="fade-down" className="navs2"><Link to="about" smooth={true} duration={1000}>ABOUT US</Link></h2>
                <h2 data-aos="fade-left" className="navs3"><Link to="service" smooth={true} duration={1000}>SERVICES</Link></h2>
                <h2 data-aos="fade-left" className="navs4"><Link to="experience" smooth={true} duration={1000}>EXPERIENCES</Link></h2>
                <h2 data-aos="fade-left" className="navs5"><Link to="projects" smooth={true} duration={1000}>PORTFOLIO</Link></h2>
                <h2 data-aos="fade-left" className="navs6"><Link to="contact" smooth={true} duration={1000}>CONTACT</Link></h2>
            </div>

            <div className="bugger" onClick={handleClick} >
                {click ? <Close style={{ color: "black", height: "10vh", width: "15vw", }} /> : <Menu className="bug" style={{ color: "black", height: "10vh", width: "15vw", }} />}
            </div>
            <div className={`boom ${show2 && "boom2"}`}>
                <Watsap />
            </div>
        </div>
    )
}

export default Header
